<template>
  <div class="boardAndLodging">
    <Header></Header>
    <Nav type="7"></Nav>
    <Toptitle title="驿声影"></Toptitle>
    <div class="article_content">
      <h2>{{videoDetail.title}}</h2>
      <video width="100%" height="300px" controls  preload="metadata" :src="videoDetail.videomedia" :poster="videoDetail.picture">
      </video>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        id: '',
        videoDetail: []
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      Toptitle
    },
    mounted() {
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.getDetail()
      }
    },
    methods: {
      getDetail() {
        this.axios.post('api/c_article/getDetail.do', this.qs({
          id: this.id
        })).then(res => {
          if (res.status == 200) {
            this.videoDetail = res.data.data
          }
        })
      }
    }
  }
</script>

<style>
</style>
